import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import styles from "./user-avatar.css";

const UserAvatar = ({ className, imageUrl }) => (
    <img
        style={{ boxShadow: "none" }}
        className={classNames(className, styles.userThumbnail)}
        src={imageUrl}
    />
);

UserAvatar.propTypes = {
    className: PropTypes.string,
    imageUrl: PropTypes.string,
};

export default UserAvatar;
